export default {
    data() {
        return {
            csrfToken: window.Laravel.csrfToken,
        };
    },
    methods: {
        route: window.route,
    },
};
